import React from 'react';
import { Snackbar, Alert, Button, Box, useMediaQuery, useTheme } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import usePwaUpdate from 'contexts/PwaUpdate';

const UpdatePrompt = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { promptVisible, applyUpdate, dismissPrompt } = usePwaUpdate();

  return (
    <Snackbar
      open={promptVisible}
      anchorOrigin={
        isMobile
          ? { vertical: 'top', horizontal: 'center' }
          : { vertical: 'bottom', horizontal: 'center' }
      }
      sx={
        isMobile
          ? { '&.MuiSnackbar-root': { top: 'calc(env(safe-area-inset-top) + 8px)' } }
          : undefined
      }
      onClose={dismissPrompt}
    >
      <Alert
        severity="info"
        action={
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Button
              color="inherit"
              size="small"
              onClick={applyUpdate}
              startIcon={<RefreshIcon />}
              sx={{ textTransform: 'none' }}
            >
              Update Now
            </Button>
            <Button
              color="inherit"
              size="small"
              onClick={dismissPrompt}
              sx={{ textTransform: 'none' }}
            >
              Later
            </Button>
          </Box>
        }
        sx={{ width: '100%' }}
      >
        A new version of the app is available. Update now to get the latest features and improvements.
      </Alert>
    </Snackbar>
  );
};

export default UpdatePrompt;
